module.exports = __webpack_public_path__ + "static/media/10.79f9ff80.jpg";